import React, { useEffect, useState } from "react";
import { notification } from "antd";
import Signin from "./Signin/Signin";
import { useAuth } from "../../provider/Auth.provider";
import { findUserByUID } from "../../service/findUsers/findUserByUID";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";

const ClubAdmin = () => {
  const { user, loading } = useAuth();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    const checkUserAccess = async () => {
      try {
        if (!user?.uid) {
          setIsSignedIn(false);
          return;
        }
        const userDetails = await findUserByUID(user.uid);
        if (userDetails?.userTypes === "club_admin") {
          setIsSignedIn(true);
          if (location.pathname !== "/clubadmin/dashboard") {
            navigate("/clubadmin/dashboard", { replace: true });
          }
          return;
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while checking user access",
          placement: "topRight",
          duration: 3,
        });
        setIsSignedIn(false);
      }
    };

    checkUserAccess();
  }, [user, navigate, location]);

  if (loading) {
    return <p>Loading...</p>;
  }

  return <>{!isSignedIn ? <Signin /> : <Dashboard />}</>;
};

export default ClubAdmin;
